"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWithPresets = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_2 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var InputAmount_1 = __importDefault(require("../../../InputAmount"));
var numberWithAbbreviates_1 = require("../../numberWithAbbreviates");
var ButtonGroup_1 = __importDefault(require("../ButtonGroup"));
var usePressets_1 = require("../ButtonGroup/usePressets");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var uniqPresetsByValue = function (presets) {
    if (!presets)
        return undefined;
    var seen = new Set();
    return presets.flatMap(function (preset) {
        var _a;
        var value = preset === null || preset === void 0 ? void 0 : preset.value;
        if (value === undefined || value === null)
            return [];
        var key = String(value);
        if (!key || key === 'NaN')
            return [];
        if (seen.has(key))
            return [];
        seen.add(key);
        return [
            {
                label: String((_a = preset === null || preset === void 0 ? void 0 : preset.label) !== null && _a !== void 0 ? _a : key),
                value: key,
            },
        ];
    });
};
var InputWithPresets = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, placeholder = _a.placeholder, min = _a.min, max = _a.max, fixedTransaction = _a.fixedTransaction, depositDefaultAmount = _a.depositDefaultAmount, currency = _a.currency, methodPresets = _a.methodPresets, props = __rest(_a, ["onChange", "placeholder", "min", "max", "fixedTransaction", "depositDefaultAmount", "currency", "methodPresets"]);
    var step = max ? (Number(max) - Number(min)) / 4 : 500;
    var form = (0, react_final_form_1.useForm)();
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var preparedMethodPresets = (0, react_1.useMemo)(function () {
        return methodPresets === null || methodPresets === void 0 ? void 0 : methodPresets.map(function (preset) { return ({
            label: String(preset === null || preset === void 0 ? void 0 : preset[currency]),
            value: Number(preset === null || preset === void 0 ? void 0 : preset[currency]),
        }); });
    }, [methodPresets, currency]);
    var generatedPresets = (0, usePressets_1.usePresets)([
        {
            label: 'MIN',
            value: min,
        },
        (0, numberWithAbbreviates_1.numbersWithAbbreviates)(Math.min(Math.ceil((Number(min) + step) / 10) * 10, Number(max))),
        (0, numberWithAbbreviates_1.numbersWithAbbreviates)(Math.min(Math.ceil((Number(min) + step * 2) / 10) * 10, Number(max))),
        (0, numberWithAbbreviates_1.numbersWithAbbreviates)(Math.min(Math.ceil((Number(min) + step * 3) / 10) * 10, Number(max))),
        {
            label: 'MAX',
            value: max,
        },
        // Include only MIN and MAX if depositWithoutPresets is true
    ].filter(function (p) {
        return (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.depositWithoutPresets)
            ? p.label === 'MIN' || p.label === 'MAX'
            : true;
    }));
    var buttonGroupOptions = (0, react_1.useMemo)(function () {
        return uniqPresetsByValue(preparedMethodPresets ? preparedMethodPresets : generatedPresets);
    }, [preparedMethodPresets, generatedPresets]);
    (0, react_2.useEffect)(function () {
        var defaultPreset = depositDefaultAmount === null || depositDefaultAmount === void 0 ? void 0 : depositDefaultAmount[currency];
        if (defaultPreset) {
            var changedAmount = min && Number(min) > defaultPreset ? min : defaultPreset;
            form.change(props.name, changedAmount);
        }
        else if (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.defaultAmountMin) {
            if (min) {
                form.change(props.name, min);
            }
        }
        else {
            var timeout_1 = setTimeout(function () {
                var _a, _b;
                if ((_a = buttonGroupOptions === null || buttonGroupOptions === void 0 ? void 0 : buttonGroupOptions[1]) === null || _a === void 0 ? void 0 : _a.value) {
                    form.change('amount', (_b = buttonGroupOptions[1]) === null || _b === void 0 ? void 0 : _b.value);
                }
            }, 100);
            return function () {
                clearTimeout(timeout_1);
            };
        }
    }, [
        min,
        (_b = buttonGroupOptions === null || buttonGroupOptions === void 0 ? void 0 : buttonGroupOptions[1]) === null || _b === void 0 ? void 0 : _b.value,
        globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.defaultAmountMin,
        depositDefaultAmount === null || depositDefaultAmount === void 0 ? void 0 : depositDefaultAmount['currency'],
    ]);
    var fixedPresetOptions = (0, usePressets_1.usePresets)((_c = fixedTransaction === null || fixedTransaction === void 0 ? void 0 : fixedTransaction.values) === null || _c === void 0 ? void 0 : _c.map(function (v) { return (0, numberWithAbbreviates_1.numbersWithAbbreviates)(v); }));
    var fixedButtonGroupOptions = (0, react_1.useMemo)(function () { return uniqPresetsByValue(fixedPresetOptions); }, [fixedPresetOptions]);
    var onPresetsChange = (0, react_2.useCallback)(function (value) {
        onChange(value);
    }, [onChange]);
    return (react_2.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat((globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.depositWithoutPresets) ? styles_module_scss_1.default.withoutPresets : '') },
        !fixedTransaction && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(InputAmount_1.default, __assign({ type: "number", placeholder: placeholder, onChange: onChange, className: styles_module_scss_1.default.inputWrapper, errorTextCentered: true }, props)),
            react_2.default.createElement(ButtonGroup_1.default, { options: buttonGroupOptions, value: props.value, className: styles_module_scss_1.default.btnGroup, onClick: onPresetsChange }))),
        fixedTransaction && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(ButtonGroup_1.default, { options: fixedButtonGroupOptions, value: props.value, className: styles_module_scss_1.default.btnsGroupOnly, onClick: onPresetsChange })))));
};
exports.InputWithPresets = InputWithPresets;
